import { Button, InlineAlert } from "@anu-its/ts-react-components";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { CreateSandpitSites, GetSandpitSites } from "@/app/api/Sites";
import { getUserId } from "@/app/firebase/utils";
import { LoadingOverlay } from "@/app/components/Loading";
import { useRouter } from "next/navigation";
import { useUserStore } from "@/app/providers/UserStore";

const CreateSandpitButton = () => {
  const { user } = useUserStore();
  const router = useRouter();

  const [userId, setUserId] = useState<string | null>(null);
  const [showButton, setShowButton] = useState(false);

  const { data } = useQuery({
    queryKey: ["GetSandpitSites", userId],
    queryFn: () => GetSandpitSites(1, "", [], userId!),
    enabled: !!userId,
  });

  useEffect(() => {
    if (data && !(data instanceof Error)) {
      if (data.sites.length === 0) {
        setShowButton(true);
      }
    }
  }, [data]);

  const createSandpitMutation = useMutation({
    mutationFn: CreateSandpitSites,
    onSuccess: (response) => {
      if (!(response instanceof Error)) {
        router.push(`/sites/${response.siteId}`);
      }
    },
  });

  useEffect(() => {
    if (user && user.email) {
      setUserId(getUserId(user.email));
    }
  }, [user]);

  if (createSandpitMutation.isPending) return <LoadingOverlay />;

  if (showButton)
    return (
      <>
        <div className="text-right pb-2">
          <Button
            variant="secondary"
            size="small"
            onClick={() =>
              createSandpitMutation.mutate({ user: user!, owner: userId! })
            }
          >
            Create me a Sandpit
          </Button>
        </div>

        {createSandpitMutation.isError && (
          <InlineAlert variant="negative">
            {createSandpitMutation.error.message}{" "}
            <a
              className="underline"
              target="_blank"
              href="https://servicedesk.anu.edu.au/sp?id=sc_cat_item&sys_id=b041e3bfdb7f1054974096888a96194f&sysparm_category=6fa33c911bd00510e8bda8aa274bcb2d"
            >
              Contact ITS for more assistance.
            </a>
          </InlineAlert>
        )}
      </>
    );
};

export default CreateSandpitButton;
